var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',[(_vm.activeCompany)?_c('div',{key:_vm.activeCompany._id,staticClass:"container-fluid"},[_c('MarqiiViews',{attrs:{"clickOut":_vm.clickOutEnabled}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }